import { render, staticRenderFns } from "./InvestmentAllocationChart.vue?vue&type=template&id=26642e6e"
import script from "./InvestmentAllocationChart.vue?vue&type=script&lang=js"
export * from "./InvestmentAllocationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports